import type { PropsWithChildren } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSession } from '../hooks/use-session'
import { useAuthStore } from '../store/auth-store'
import { FullPageLoader } from '../../shared/components/FullPageLoader'

export function ProtectedRoute({ children }: PropsWithChildren) {
  useSession()
  const user = useAuthStore((state) => state.user)
  const initialized = useAuthStore((state) => state.initialized)
  const location = useLocation()

  if (!initialized) {
    return <FullPageLoader label="Validando sessão" />
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
  }

  return children
}
